import './polyfills'
import '@fontsource-variable/open-sans'
import { ModuleRegistry, RenderApiModule } from 'ag-grid-enterprise'
import { setWorkerUrl } from 'maplibre-gl'
import maplibreWorkerUrl from './maplibre-worker.ts?worker&url'
import { createSSRApp } from 'vue'

import { markExternalLinks } from './external-links'
import { createFrankfurtPlusApp } from './inertia'
import { recoverFromStaleAssets } from './stale-assets'
import './tailwind.css'
import sentryVuePlugin from '@/app/sentry'

setWorkerUrl(maplibreWorkerUrl)
ModuleRegistry.registerModules([RenderApiModule])

recoverFromStaleAssets()

// eslint-disable-next-line unicorn/prefer-top-level-await
void createFrankfurtPlusApp({
  appFactory: createSSRApp,
  enhance(app) {
    app.use(sentryVuePlugin)

    markExternalLinks(document.body)

    document.addEventListener('inertia:finish', () => {
      markExternalLinks(document.body)
    })

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            markExternalLinks(node as Element)
          }
        }
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })
  },
})
